import { useReactiveVar } from '@apollo/client';

import { Box } from '@mui/material';
import { InstallationsListSection } from 'modules/components/layer35';
import { InstallationFilterBar } from 'modules/components/layer11';
import { filterInstallationsVar } from 'modules/common/layer00/reactiveVariables';
import React from 'react';



export type ProjectInstallationsSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationsSectionProps) => {
  useReactiveVar(filterInstallationsVar);
  return (
    <Box
      display='flex'
      flexDirection='column'
      rowGap='1rem'
    >
      {/* FILTERS */}
      <InstallationFilterBar.FC />
      <InstallationsListSection.FC />
    </Box>
  );
};
